import { defineStore } from "pinia";
import {
  ChatbaseService,
  type TokenJson
} from "@/client";

export const useChatStore = defineStore("chat", () => {
  async function getChatbaseToken() {
    return await ChatbaseService.getApiChatbase()
      .then((response: TokenJson) => {
        if (window.chatbase && response.token != "")
          window.chatbase('identify', { response });
        return Promise.resolve(response);
      })
      .catch((error: any) => {
        return Promise.reject(error);
      });
  }

  return {
    getChatbaseToken
  };
});
